import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { Layout } from "./components/Layout";
import { Dashboard } from "./pages/Dashboard";
import { Features } from "./pages/Features";
import { Home } from "./pages/Home";
import { NotFound } from "./pages/NotFound";
import { TopCombinations } from "./pages/TopCombinations";

function AppRoutes() {
    return (
        <QueryParamProvider adapter={ReactRouter6Adapter}>
            {/* Anchor-scoped routes are also listed in ANCHOR_PATHS (utils/anchor.ts) for analytics. */}
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="top" element={<TopCombinations />} />
                    <Route path="analysis" element={<Dashboard />} />
                    <Route path="features" element={<Features />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </QueryParamProvider>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    );
}
